export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/prebid-stack/prebid-stack-gam-setup'

export const MAX_PROPOSAL_ITEMS = 10
